import React, { useState } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  CalendarIcon,
} from "@heroicons/react/24/outline";
import { Menu } from "@headlessui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateNavigator = ({
  onPrevDay,
  onToday,
  onNextDay,
  onPrevWeek,
  onNextWeek,
  onDateChange,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateChange(date);
    setIsCalendarOpen(false);
  };

  const handleCalendarClose = () => {
    setIsCalendarOpen(false);
  };

  const handleCalendarOpen = (e) => {
    e.preventDefault();
    setIsCalendarOpen(true);
  };

  const buttonBaseClasses = "flex flex-col items-center justify-center p-2 rounded-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 hover:bg-gray-100";

  return (
    <div data-component="DateNavigator" className="flex items-center gap-1 bg-white p-1 rounded-sm shadow-sm border border-gray-200">
      {/* Prev week */}
      <button
        type="button"
        className={buttonBaseClasses}
        onClick={onPrevWeek}
        title="Previous Week"
      >
        <ChevronDoubleLeftIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        <span className="text-xs text-gray-600 mt-1">Prev week</span>
      </button>

      {/* Prev day */}
      <button
        type="button"
        className={buttonBaseClasses}
        onClick={onPrevDay}
        title="Previous Day"
      >
        <ChevronLeftIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        <span className="text-xs text-gray-600 mt-1">Prev day</span>
      </button>

      {/* Calendar Icon */}
      <Menu as="div" className="relative">
        <Menu.Button
          className={`${buttonBaseClasses} mx-1`}
          onClick={handleCalendarOpen}
        >
          <CalendarIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        </Menu.Button>
        {isCalendarOpen && (
          <div className="absolute z-10 mt-2 w-auto bg-white rounded-sm shadow-lg border border-gray-200 p-2">
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              inline
              onClickOutside={handleCalendarClose}
              onCalendarClose={handleCalendarClose}
              calendarClassName="shadow-none border-0"
            />
          </div>
        )}
      </Menu>

      {/* Today */}
      <button
        type="button"
        className={`${buttonBaseClasses} px-4`}
        onClick={onToday}
      >
        <span className="text-sm font-medium text-indigo-600">Today</span>
      </button>

      {/* Next day */}
      <button
        type="button"
        className={buttonBaseClasses}
        onClick={onNextDay}
        title="Next Day"
      >
        <ChevronRightIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        <span className="text-xs text-gray-600 mt-1">Next day</span>
      </button>

      {/* Next week */}
      <button
        type="button"
        className={buttonBaseClasses}
        onClick={onNextWeek}
        title="Next Week"
      >
        <ChevronDoubleRightIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        <span className="text-xs text-gray-600 mt-1">Next week</span>
      </button>
    </div>
  );
};

export default DateNavigator;
